export default "skymp5-front/0ada24b4328c523bc6dea259f05452a3.png";